<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        enctype="multipart/form-data"
        :data-url="
          selectedUrl
            ? `/accreditationReview/evaluationTeam/reviewObjections/${inputs.id}`
            : `/accreditationReview/evaluationTeam/reviewObjections`
        "
      >
        <div class="row" v-if="evaluationList && evaluationList.length > 0">
          <div class="col-12">
            <app-note
              class="pt-2 clearfix"
              :title="$t('Procesos en bloque')"
              content-type="html"
              note-type="note-warning"
              :notes="[
                $t(
                  'Al realizar la objeción de la propuesta de equipo evaluador se efectuará la misma acción para las siguientes evaluaciones o testificaciones'
                ),
              ]"
            />
          </div>
          <br />
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">Expediente</th>
                  <th scope="col">Tipo</th>
                  <th scope="col">Código</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in evaluationList" :key="key">
                  <td class="align-middle">
                    {{ value.accreditation_applications.record }}
                  </td>
                  <td class="align-middle">
                    <br />
                    <p v-if="value.type == 'E'">Evaluación</p>
                    <p v-if="value.type == 'T'">Testificación</p>
                  </td>
                  <td class="align-middle">{{ value.code }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row" v-if="observations_303.length > 0">
          <div class="col-12">
            <div class="form-group">
              <label>Objeciones OEC</label>
              <table class="table table-sm table-striped text-center">
                <thead>
                  <tr>
                    <th scope="col">Observación</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Usuario</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in observations_303" :key="index">
                    <td>{{ value.observation }}</td>
                    <td>{{ dateToString(value.created_at) }}</td>
                    <td>{{ value.user.full_name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row" v-if="observations_305.length > 0">
          <div class="col-12">
            <div class="form-group">
              <label>Respuestas Objeción Gestor</label>
              <table class="table table-sm table-striped text-center">
                <thead>
                  <tr>
                    <th scope="col">Observación</th>
                    <th scope="col">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in observations_305" :key="index">
                    <td>{{ value.observation }}</td>
                    <td>{{ dateToString(value.created_at) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label>Propuesta del equipo evaluador</label>
              <div>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab('evaluation_team_file')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-sm-12 col-md-6"
            v-if="inputs.file_evaluation_objetion"
          >
            <div class="form-group">
              <label>Documentación Adicional OEC</label>
              <div>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab('file_evaluation_objetion')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="submit" class="btn btn-primary" @click.prevent="submit">
        Enviar a Gestor para Revisión
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "modal-add-edit",
      evaluationList: "",
      confirm: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },

    observations_303() {
      let tmp = [];
      if (this.inputs.observations_evaluation_team) {
        tmp = this.inputs.observations_evaluation_team.filter(
          (item) => item.status.code == "303"
        );
      }
      return tmp;
    },

    observations_305() {
      let tmp = [];
      if (this.inputs.observations_evaluation_team) {
        tmp = this.inputs.observations_evaluation_team.filter(
          (item) => item.status.code == "305"
        );
      }
      return tmp;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    afterSuccessFromGetEditData({ data: data }) {
      this.preloader = false;
      this.inputs = data;

      if (data.evaluationList && data.evaluationList.length > 0) {
        this.evaluationList = data.evaluationList;
      }
    },

    openTab(fileName) {
      const w = window.open(this.inputs[fileName].path, "_blank");
      w.focus();
    },

    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD") : null;
    },
  },
};
</script>
